const SUMMARY = {
    greet: "Hello! Good Day",
    title: "My Name is Halley",
    subTitle: "To be associated with a progressive organization that gives scope to \
        apply my knowledge and skills and to be part of a team that dynamically works \
        towards the growth of the organization allowing me to pursue a challenging and \
        satisfying carreer."
}

export default SUMMARY;